import { useContext } from 'react'
import NewEnvironmentSuite from '@cbgms/components/environment/environmentUtils'
import { EnvironmentContext } from 'app-support/contexts/EnvironmentContext'
import { SupportEnvironment } from 'core/enums/enums'

const useEnvironment = () => {
  const { environment } = useContext(EnvironmentContext)
  return environment
}

const useSimulatedEnvironment = () => {
  const { simulatedEnvironment } = useContext(EnvironmentContext)
  return simulatedEnvironment
}

const useSetSimulatedEnvironment = () => {
  const { setSimulatedEnvironment } = useContext(EnvironmentContext)
  return setSimulatedEnvironment
}

const suite = NewEnvironmentSuite(SupportEnvironment, {
  useEnvironment,
  useSimulatedEnvironment,
  useSetSimulatedEnvironment
})

export const EnvironmentFeature = suite.EnvironmentFeature
export const useHasEnvironmentFeature = suite.useHasEnvironmentFeature
export const useHasEnvironmentFeatureFunc = suite.useHasEnvironmentFeatureFunc
export const EnvironmentSimulator = suite.EnvironmentSimulator
export default suite.EnvironmentFeature
